// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class AdjustedPricingCompany {
  readonly id: string;
  readonly name: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
  }

  static zero(): AdjustedPricingCompany {
    const zeroValues: ExcludeMethodsDeep<AdjustedPricingCompany> = {
      id: NIL_UUID,
      name: '',
    };
    return new AdjustedPricingCompany(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AdjustedPricingCompanyWireFormat = {
  id: string;
  name: string;
};

type NewAdjustedPricingCompanyProps = PartialDeep<
  AdjustedPricingCompany,
  { recurseIntoArrays: true }
>;
export const NewAdjustedPricingCompany: (
  props: NewAdjustedPricingCompanyProps,
) => AdjustedPricingCompany = (props) => new AdjustedPricingCompany(props);

type NewAdjustedPricingCompanyFromWireFormatProps = PartialDeep<
  AdjustedPricingCompanyWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAdjustedPricingCompanyFromWireFormat: (
  props: NewAdjustedPricingCompanyFromWireFormatProps,
) => AdjustedPricingCompany = (props) => new AdjustedPricingCompany(props);
